import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import SiteNav from "@/components/layout/SiteNav";
import Footer from "@/components/layout/Footer";
import { setCanonical, canonicalFor } from "@/lib/seo";

const Layout = () => {
  const location = useLocation();
  useEffect(() => {
    setCanonical(canonicalFor(location));
  }, [location]);

  return (
    <div className="parchment min-h-screen flex flex-col bg-[#fdfdfb] text-[#14140f]">
      <SiteNav />
      <main className="relative z-10 flex-1 flex flex-col min-h-0">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
